import { getAppChoicesFromKey, getSortedCountyValues } from "./global";

export const APP_URL = process.env.REACT_APP_APP_URL;

export const SCRIPT_PROD_URL =
  "https://script.google.com/macros/s/AKfycbz9LfOON0qZ0kSO-zwaG1kpgh9aauyZ5HNugNbFX9TWpXVjWX2dvbg1mWWf4p_bbTw/exec";
export const BRAND_NAME = "ATM Surveying";
export const MAP_KEY = "AIzaSyDWEltoJsd6CNoHV0ZyxvMnBuiQamXb2Kw";

export const MAX_CHUNK_SIZE = 48 * 1024 * 1024; // 48MB

export const ENDPOINTS = {
  //Users
  LOGIN: "/users/login",
  REGISTER: "/users/register",
  FORGOT_PASSWORD: "/users/send-password-reset-link",
  RESET_PASSWORD: "/users/reset-password",
  CHANGE_PASSWORD: "/users/change-password",
  GENERATE_REGISTRATION_OTP: "/users/generate-registration-otp",
  GET_ME: "/users/me",
  UPDATE_USER_DETAILS: "/users/update-user-details",
  CREATE_USER: "/users",
  USERS_LIST: "/users/search",
  GET_USER_STATS: "/time-tracking/user-job-details",

  // timer-tracking
  CLOCK_IN: "/time-tracking/clockIn",
  CLOCK_OUT: "/time-tracking/clockOut",
  GET_TIME_LOGS: "/time-tracking/list",
  CREATE_LOG: "/time-tracking/create",
  DELETE_LOG: (id) => `/time-tracking/delete/${id}`,
  UPDATE_LOG: (id) => `/time-tracking/edit/${id}`,
  UPDATE_MULTIPLE_LOG: "/time-tracking/edit",
  RESET_TIME: "/time-tracking/extend-timer",
  // jobs
  CREATE_JOBS: "/jobs",
  SEARCH_JOBS: "/jobs/search",
  GET_JOBS: "/jobs/search",
  UPDATE_INDIVIDUAL_JOB: (id) => `/jobs/${id}`,
  UPDATE_BULK_JOBS: "/jobs",
  FIND_NEARBY_JOBS: (id) => `/jobs/nearby/${id}`,
  SEND_CONTRACT: (id) => `/jobs/send-contract/${id}`,
  GET_JOBS_FROM_UUID: (id) => `/jobs/uuid/${id}`,
  CONTRACT_ACTION: (id) => `/jobs/contract-action/${id}`,
  GET_JOB_SCHEDULE: "/jobs/schedule",

  // finance dashboard
  GET_SALES_FINANCE_DASHBOARD_DATA: "/finance-dashboard/sales",
  GET_PROFIT_AND_LOSS_FINANCE_DASHBOARD_DATA: "/finance-dashboard/profit-loss",
  GET_CASHFLOW_TREND_FINANCE_DASHBOARD_DATA:
    "/finance-dashboard/cash-flow-trend",

  //App Choices
  APP_CHOICES_BASE: "/app-choices",
  APP_CHOICES_LIST: "/app-choices/list",
  APP_CHOICES_WITH_ID: (id) => `/app-choices/${id}`,

  // CSV
  DOWNLOAD_CSV_SERVICE: "/jobs/csv",

  // Holidays
  GET_HOLIDAYS: "/holidays/list",
  SET_HOLIDAYS: "/holidays",
};

export const USER_STATUS = ["Enable", "Disable"];

export const PAGE_SIZE = 50;

export const DEFAULT_PAGE_SIZE = 20;
export const STATUS = [
  "Quoting",
  "Cancelled",
  "Pending Approval",
  "Agreed-send contract",
  "Pending Confirm",
  "Invoicing",
  "Field Setup",
  "Field Work",
  "Drafting",
  "Reviewing",
  "Archiving",
  "Rod Setting",
  "Stuck",
  "Completed",
];

export const labelToKeyMap = {
  "First Name": "firstName",
  "Last Name": "lastName",
  "Request Commit": "requestCommit", // Not In Create Form
  "Flood Zone Check": "floodZoneCheck", // Not In Create Form
  "Request Deeds": "requestDeeds", // Not In Create Form
  "Invoice Sent": "invoiceSent", // Not In Create Form
  "Invoice Paid": "invoicePaid", // Not In Create Form
  "Invoice Sent Date": "invoiceSentDate", // Not In Create Form
  "Invoice Paid Date": "invoicePaidDate", // Not In Create Form
  "Company / Referrer's name": "companyReferrerName", // this
  Phone: "phone",
  "E-mail": "email",
  "Is Client Responsible for payment a different person?": "isClientDifferent",
  "Client Name": "clientName",
  "Client Email": "clientEmail",
  "Type of Land Survey": "typeOfLandSurvey",
  "Property Address": "propertyAddress",
  "Property Street Name": "propertyStreet",
  City: "city",
  County: "county",
  "Property Appraisal ID": "propertyAppraisalId",
  "Proposed Due Date": "proposedDueDate",
  "Title Closing Date": "titleClosingDate",
  "Title Company": "titleCompany",
  "Additional notes or requests": "additionalNotesOrRequests",

  //for edit
  "Agreed Due Date": "agreedDueDate",
  "Client Priority": "clientPriority",
  Value: "value",
  "Field Time": "fieldTime",
  "Drafting Time": "draftingTime",
  "Reviewing Time": "reviewingTime",
  "Is there a closing?": "isThereAClosing",
  Latitude: "latitude",
  Longitude: "longitude",
  Status: "status",
  "Field Staff": "fieldStaff",
  Draftsman: "draftsman",
  Reviewer: "reviewer",
  Acreage: "acreage",
  Files: "files",
  fileNames: "files",
  Subdivision: "subDivision",
  Lot: "lot",
  Block: "block",
  Abstract: "abstract",
  "Abstract Number": "abstractNumber",
  "Wooded percent": "woodedPercent", // this
  "Creek length": "creekLength",
  "Subdivision age": "subDivisionAge",
  Urgent: "urgent",
  Difficulty: "difficulty",
  "Distance to property in hours": "distanceToPropertyInHours",
  Comment: "comment",
  "Contract UUID": "contractUuid",
  "Contract Status": "contractStatus",
  "Status Log": "statusLog", // this
  Tasks: "tasks",
};

export const datefields = [
  "Submission Date",
  "Proposed Due Date",
  "Title Closing Date",
  "Agreed Due Date",
  "Closing minus agreed due date",
  "Closing minus proposed due date",
  "Days until closing",
];

export const checkFields = [
  "Is there a closing?",
  "Urgent",
  "Request Commit",
  "Flood Zone Check",
  "Request Deeds",
  "Invoice Sent",
  "Invoice Paid",
];

export const numFields = [
  "Field Time",
  "Drafting Time",
  "Reviewing Time",
  "Acreage",
  "Wooded percent",
  "Creek length",
  "Subdivision age",
  "Distance to property in hours",
  "Value",
];

export const dropdownFields = [
  "Type of Land Survey",
  "Status",
  "Field Staff",
  "Draftsman",
  "Reviewer",
  "Difficulty",
  "Client Priority",
  "County",
];

export const textFields = [
  "Contract Status",
  "Closing minus agreed due date",
  "Closing minus proposed due date",
  "Days until closing",
  "Due date met?",
  "Waiting For Quote",
];
export const iconFields = [
  "folder",
  "appr",
  "apprMap",
  "apprImage",
  "googleMap",
  "view",
];

export const surveyForm = (appChoices) => ({
  forms: [
    {
      name: "request-form-submit",
      hideFormName: true,
      markCompulsoryFields: true,
      compact: true,
      submit: {
        id: "request-form-submit",
        name: "Submit",
        show: false,
        onSubmit: "onRequestFormSubmit",
        noAdditionalSpacing: true,
      },

      columnAlignSelf: "end",
      labelFontSize: "9px", //sets the font size form all input field
      rows: [
        {
          columns: [
            {
              default: 2,
              xs: 12,
              field: {
                id: "firstName",
                title: "First Name",
                type: "text",
                required: true,
                style: { fontSize: "10px" },
              },
            },
            {
              default: 2,
              xs: 12,
              field: {
                id: "lastName",
                title: "Last Name",
                type: "text",
                required: true,
                style: { fontSize: "10px" },
              },
            },

            {
              default: 2,
              xs: 12,
              field: {
                title: "Company / Referrer's name",
                id: "companyReferrerName",
                type: "text",
                required: true,
                style: { fontSize: "10px" },
              },
            },
            {
              default: 2,
              xs: 12,
              field: {
                id: "phone",
                title: "Your Phone Number",
                type: "text",
                required: true,
                style: { fontSize: "10px" },
              },
            },
            {
              default: 2,
              xs: 12,
              field: {
                id: "email",
                title: "Your Email Address",
                type: "text",
                variant: "email",
                required: true,
                style: { fontSize: "10px" },
              },
            },
            {
              default: 2,
              xs: 12,
              field: {
                id: "typeOfLandSurvey",
                title: "Type of Land Survey needed",
                type: "dropdown",
                options: getAppChoicesFromKey(
                  appChoices,
                  "Type of Land Survey"
                ),
                required: true,
                style: { fontSize: "10px" },
              },
            },
          ],
        },
        {
          columns: [
            {
              default: 2,
              xs: 12,
              className: "align-self-end",
              field: {
                id: "isClientDifferent",
                type: "checkbox",
                label: "Is Client Responsible for payment a different person?",
                showLabel: true,
                defaultChecked: true,
                onChange: "onClientDifferentChange",
                labelStyle: { fontSize: "10px" },
                style: { fontSize: "10px" },
              },
            },
            {
              default: 2,
              xs: 12,
              field: {
                id: "clientName",
                type: "text",
                title: "Client Name",
                required: true,
                style: { fontSize: "10px" },
              },
            },
            {
              default: 2,
              xs: 12,
              field: {
                id: "clientEmail",
                type: "text",
                title: "Client Email",
                variant: "email",
                required: true,
                style: { fontSize: "10px" },
              },
            },
            {
              default: 2,
              xs: 12,
              field: {
                id: "propertyAddress",
                title: "Property Number (address)",
                type: "text",
                required: true,
                hint: "Eg: 1234 (Type 0000 if no. doesn't exist)",
                style: { fontSize: "10px" },
              },
            },
            {
              default: 2,
              xs: 12,
              field: {
                id: "propertyStreet",
                title: "Property Street Name",
                type: "text",
                required: true,
                hint: "Eg: Main St",
                style: { fontSize: "10px" },
              },
            },
            {
              default: 2,
              xs: 12,
              field: {
                id: "city",
                title: "City",
                type: "text",
                required: true,
                style: { fontSize: "10px" },
              },
            },
          ],
        },

        {
          columns: [
            {
              default: 12,

              field: {
                type: "custom-html",
                style: { fontSize: "10px" },

                html: `
              <h6 id='contractWarningText' class='text-primary tinner-text mb-0 '>
                The offer for this survey will be sent to the client. If you want to receive the offer instead, please uncheck this box.
              </h6>`,
              },
            },
          ],
        },
        {
          columns: [
            {
              default: 2,
              xs: 12,
              field: {
                id: "county",
                title: "County",
                type: "dropdown",
                options: [...getSortedCountyValues(appChoices)],
                required: true,
                style: { fontSize: "10px" },
              },
            },
            {
              default: 2,
              xs: 12,
              field: {
                id: "propertyAppraisalId",
                title: "Property Appraisal ID",
                type: "text",
                required: false,
                style: { fontSize: "10px" },
              },
            },

            {
              default: 2,
              xs: 12,
              field: {
                id: "titleCompany",
                title: "Title Company",
                type: "dropdown",
                options: [...getAppChoicesFromKey(appChoices, "Title Company")],
                required: true,
                dependentElem: "titleOther",
                style: { fontSize: "10px" },
                showDependentOn: "Other",
              },
            },
            {
              default: 3,
              className: "align-self-end",
              xs: 12,
              field: {
                id: "titleClosingDate",
                title: "Scheduled Closing date at Title Company.",
                type: "text",
                required: true,
                variant: "date",
                style: { fontSize: "10px" },
              },
            },
            {
              default: 3,
              xs: 12,
              field: {
                id: "proposedDueDate",
                title:
                  "Due Date NEEDED. Next available is shown. (WEEKENDS & Holidays are blocked.)",
                type: "text",
                required: true,
                variant: "date",
                style: { fontSize: "10px" },
              },
            },
          ],
        },

        {
          columns: [
            {
              default: 12,
              className: "",
              field: {
                id: "titleOther",
                hint: "Email address of other title company...",
                type: "text",
                required: true,
                style: { fontSize: "10px" },
              },
            },
          ],
        },

        {
          columns: [
            {
              default: 12,
              xs: 12,
              field: {
                id: "additionalNotesOrRequests",
                title: "Additional Notes or Requests",
                type: "text-area",
                required: false,
                rows: 1,
                style: { fontSize: "10px" },
              },
            },
          ],
        },
      ],
    },
  ],
});

const additionalSurveyEditFields = [
  {
    default: 2,
    xs: 12,
    field: {
      id: "fieldTime",
      type: "number",
      title: "Field Time",
      required: false,
      style: { fontSize: "10px" },
    },
  },
  {
    default: 2,
    xs: 12,
    field: {
      id: "draftingTime",
      type: "number",
      title: "Drafting Time",
      required: false,
      style: { fontSize: "10px" },
    },
  },
  {
    default: 2,
    xs: 12,
    field: {
      id: "reviewingTime",
      type: "number",
      title: "Reviewing Time",
      required: false,
      style: { fontSize: "10px" },
    },
  },
  {
    default: 2,
    xs: 12,
    field: {
      id: "latitude",
      title: "Latitude",
      type: "number",
      required: false,
      style: { fontSize: "10px" },
    },
  },
];

export const surveyEditForm = (role, appChoices) => ({
  forms: [
    {
      name: "View survey",
      hideFormName: true,
      markCompulsoryFields: true,
      compact: true,
      columnAlignSelf: "end",
      submit: {
        name: "Submit",
        show: true,
        onSubmit: "onRequestEditFormSubmit",
        isSticky: true,
      },
      rows: [
        {
          columns: [
            {
              default: 8,
              xs: 12,
              className: "align-self-end mb-2",
              field: {
                type: "custom-html",
                html: `<h5 class="mb-0 small-text">
                    <b>View survey</b>
                  </h5>
                  <h6 id="idContainer" class="mt-1 mb-0 tinner-text">
                  ATM ID: <span id="atmId" class="text-muted">N/A</span>
                  </h6>
                  <h6 id="licenseContainer" class="mt-1 mb-0 tinner-text">
                  Driver License #: <span id="driverLicense" class="text-muted">N/A</span>
                  </h6>

                  <hr class="d-md-none"/>`,
                style: { fontSize: "10px" },
              },
            },
            {
              default: 4,
              xs: 12,
              className: "bg-primary text-white rounded p-1 mb-2",
              field: {
                id: "status",
                title: "Status",
                type: "dropdown",
                required: true,
                options: STATUS,
                onChange: "updateDateSetup",
                style: { fontSize: "10px" },
              },
            },
          ],
        },
        {
          columns: [
            {
              default: 1,
              xs: 12,
              className: "align-self-start ",
              field: {
                id: "urgent",
                style: { fontSize: "10px" },
                type: "checkbox",
                label: "Urgent",
                required: false,
                showLabel: true,
              },
            },
            {
              default: 2,
              xs: 12,
              className: "align-self-start ",
              field: {
                id: "requestCommit",
                type: "checkbox",
                label: "Request Commit",
                required: false,
                showLabel: true,
                style: { fontSize: "10px" },
              },
            },
            {
              default: 2,
              xs: 12,
              className: "align-self-start ",
              field: {
                id: "floodZoneCheck",
                type: "checkbox",
                label: "Flood Zone Check",
                required: false,
                showLabel: true,
                style: { fontSize: "10px" },
              },
            },
            {
              default: 2,
              xs: 12,
              className: "align-self-start ",
              field: {
                id: "requestDeeds",
                type: "checkbox",
                label: "Request Deeds",
                required: false,
                showLabel: true,
                style: { fontSize: "10px" },
              },
            },
            {
              default: 1,
              xs: 6,
              className: "align-self-start pr-md-0",
              field: {
                id: "invoiceSent",
                type: "checkbox",
                label: "Invoice Sent",
                required: false,
                showLabel: true,
                onChange: "onInvoiceCheckboxValuesChange",
                style: { fontSize: "10px" },
              },
            },
            {
              default: 1,
              xs: 6,
              className: "align-self-start p-xs-2 p-md-0 ml-md-3",
              field: {
                id: "invoiceSentDate",
                type: "text",
                variant: "date",
                label: "Invoice Sent Date",
                required: false,
                preValue: new Date(),
                style: { fontSize: "10px", width: "104px" },
              },
            },
            {
              default: 1,
              xs: 6,
              className: "align-self-start pr-md-0",
              field: {
                id: "invoicePaid",
                type: "checkbox",
                label: "Invoice Paid",
                showLabel: true,
                required: false,
                onChange: "onInvoiceCheckboxValuesChange",
                style: { fontSize: "10px" },
              },
            },
            {
              default: 1,
              xs: 6,
              className: "align-self-start p-xs-2 p-md-0 ml-md-3",
              field: {
                id: "invoicePaidDate",
                type: "text",
                variant: "date",
                label: "Invoice Paid Date",
                required: false,
                preValue: new Date(),
                style: { fontSize: "10px", width: "104px" },
              },
            },
          ],
        },
        {
          columns: [
            {
              default: 2,
              xs: 12,
              field: {
                id: "firstName",
                title: "First Name",
                type: "text",
                required: true,
                style: { fontSize: "10px" },
              },
            },
            {
              default: 2,
              xs: 12,
              field: {
                id: "lastName",
                title: "Last Name",
                type: "text",
                style: { fontSize: "10px" },
                required: true,
              },
            },
            {
              default: 2,
              xs: 12,
              field: {
                title: "Your company name / or who referred you to us",
                id: "companyReferrerName",
                type: "text",
                required: true,
                style: { fontSize: "10px" },
              },
            },
            {
              default: 2,
              xs: 12,
              field: {
                id: "phone",
                title: "Your Phone Number",
                type: "text",
                required: true,
                style: { fontSize: "10px" },
              },
            },
            {
              default: 2,
              xs: 12,
              field: {
                id: "email",
                title: "Your Email Address",
                type: "text",
                variant: "email",
                required: true,
                style: { fontSize: "10px" },
              },
            },
            {
              default: 2,
              xs: 12,
              field: {
                id: "typeOfLandSurvey",
                title: "Type of Land Survey needed",
                type: "dropdown",
                options: [
                  ...getAppChoicesFromKey(appChoices, "Type of Land Survey"),
                ],
                required: true,
                style: { fontSize: "10px" },
              },
            },
          ],
        },

        {
          columns: [
            {
              default: 2,
              xs: 12,
              className: "align-self-end",
              field: {
                id: "isClientDifferent",
                type: "checkbox",
                label: "Is Client Responsible for payment a different person?",
                showLabel: true,
                defaultChecked: true,
                onChange: "onClientDifferentChange",
                style: { fontSize: "10px" },
              },
            },
            {
              default: 2,
              xs: 12,
              field: {
                id: "clientName",
                type: "text",
                title: "Client Name",
                required: true,
                style: { fontSize: "10px" },
              },
            },
            {
              default: 2,
              xs: 12,
              field: {
                id: "clientEmail",
                type: "text",
                title: "Client Email",
                required: true,
                style: { fontSize: "10px" },
              },
            },
            {
              default: 2,
              xs: 12,
              field: {
                id: "isThereAClosing",
                title: "Is there a closing?",
                type: "radio",
                options: ["yes", "no"],
                required: false,
                style: { fontSize: "10px" },
              },
            },
            {
              default: 2,
              xs: 12,
              field: {
                id: "propertyAddress",
                title: "Property Number (address)",
                type: "text",
                required: true,
                hint: "Eg: 1234 (Type 0000 if no. doesn't exist)",
                style: { fontSize: "10px" },
              },
            },
            {
              default: 2,
              xs: 12,
              field: {
                id: "propertyStreet",
                title: "Property Street Name",
                type: "text",
                required: true,
                hint: "Eg: Main St",
                style: { fontSize: "10px" },
              },
            },
          ],
        },

        {
          columns: [
            {
              default: 2,
              xs: 12,
              field: {
                id: "city",
                title: "City",
                type: "text",
                required: true,
                style: { fontSize: "10px" },
              },
            },
            {
              default: 1,
              xs: 12,
              field: {
                id: "county",
                title: "County",
                type: "dropdown",
                options: [...getSortedCountyValues(appChoices)],
                required: true,
                style: { fontSize: "10px" },
              },
            },
            {
              default: 2,
              xs: 12,
              field: {
                id: "propertyAppraisalId",
                title: "Property Appraisal ID",
                type: "text",
                required: false,
                style: { fontSize: "10px" },
              },
            },
            {
              default: 1,
              xs: 12,
              field: {
                id: "titleCompany",
                title: "Title Company",
                type: "dropdown",
                options: [
                  "None",
                  "Aggieland Title",
                  "University Title",
                  "Other",
                ],
                required: true,
                dependentElem: "titleOther",
                showDependentOn: "Other",
                style: { fontSize: "10px" },
              },
            },
            {
              default: 2,
              className: "",
              field: {
                id: "titleOther", // this
                hint: "Email address of other title company...",
                type: "text",
                required: true,
                style: { fontSize: "10px" },
              },
            },
            {
              default: 2,
              xs: 12,
              field: {
                id: "proposedDueDate",
                title: "Proposed Due Date",
                type: "text",
                required: true,
                variant: "date",
                style: { fontSize: "10px" },
              },
            },
            {
              default: 2,
              className: "align-self-end",
              xs: 12,
              field: {
                id: "titleClosingDate",
                title: "Scheduled Closing date at Title Company.",
                type: "text",
                required: true,
                variant: "date",
                style: { fontSize: "10px" },
              },
            },
          ],
        },

        {
          columns: [
            {
              default: 12,
              xs: 12,
              field: {
                id: "additionalNotesOrRequests",
                title: "Additional Notes or Requests",
                type: "text-area",
                required: false,
                style: { fontSize: "10px" },
              },
            },
          ],
        },
        {
          columns: ["Admin", "Manager"].includes(role)
            ? [
                {
                  default: 2,
                  xs: 12,
                  field: {
                    id: "agreedDueDate",
                    title: "Agreed Due Date",
                    type: "text",
                    variant: "date",
                    style: { fontSize: "10px" },
                    required: false,
                  },
                },
                {
                  default: 1,
                  xs: 12,
                  field: {
                    id: "clientPriority",
                    type: "dropdown",
                    options: [
                      ...getAppChoicesFromKey(appChoices, "Client Priority"),
                    ],
                    title: "Client Priority",
                    required: false,
                    style: { fontSize: "10px" },
                  },
                },
                {
                  default: 1,
                  xs: 12,
                  field: {
                    id: "value",
                    title: "Budget",
                    type: "number",
                    required: false,
                    style: { fontSize: "10px" },
                  },
                },
                ...additionalSurveyEditFields,
              ]
            : [
                {
                  default: 2,
                  xs: 12,
                  field: {
                    id: "agreedDueDate",
                    title: "Agreed Due Date",
                    type: "text",
                    variant: "date",
                    required: false,
                    style: { fontSize: "10px" },
                  },
                },
                {
                  default: 1,
                  xs: 12,
                  field: {
                    id: "clientPriority",
                    type: "dropdown",
                    options: [
                      ...getAppChoicesFromKey(appChoices, "Client Priority"),
                    ],
                    title: "Client Priority",
                    required: false,
                    style: { fontSize: "10px" },
                  },
                },
                ...additionalSurveyEditFields,
              ],
        },

        {
          columns: [
            {
              default: 2,
              xs: 12,
              field: {
                id: "longitude",
                type: "number",
                title: "Longitude",
                required: false,
                style: { fontSize: "10px" },
              },
            },
            {
              default: 2,
              xs: 12,
              field: {
                id: "acreage",
                type: "text",
                title: "Acreage",
                required: false,
                style: { fontSize: "10px" },
              },
            },
            {
              default: 2,
              xs: 12,
              field: {
                id: "fieldStaff",
                title: "Field Staff",
                type: "dropdown",
                options: getAppChoicesFromKey(appChoices, FIELD_STAFF_ROLE),
                required: false,
                style: { fontSize: "10px" },
              },
            },
            {
              default: 2,
              xs: 12,
              field: {
                id: "draftsman",
                title: "Draftsman",
                type: "dropdown",
                options: getAppChoicesFromKey(appChoices, DRAFTSMAN_ROLE),
                required: false,
                style: { fontSize: "10px" },
              },
            },
            {
              default: 2,
              xs: 12,
              field: {
                id: "reviewer",
                title: "Reviewer",
                type: "dropdown",
                options: getAppChoicesFromKey(appChoices, REVIEWER_ROLE),
                style: { fontSize: "10px" },
                required: false,
              },
            },
            {
              default: 2,
              xs: 12,
              field: {
                id: "subDivision",
                title: "Sub Division",
                type: "text",
                required: false,
                style: { fontSize: "10px" },
              },
            },
          ],
        },

        {
          columns: [
            {
              default: 1,
              xs: 12,
              field: {
                id: "lot",
                type: "text",
                title: "Lot",
                required: false,
                style: { fontSize: "10px" },
              },
            },
            {
              default: 1,
              xs: 12,
              field: {
                id: "block",
                type: "text",
                title: "Block",
                required: false,
                style: { fontSize: "10px" },
              },
            },
            {
              default: 1,
              xs: 12,
              field: {
                id: "abstract",
                title: "Abstract",
                type: "text",
                required: false,
                style: { fontSize: "10px" },
              },
            },
            {
              default: 1,
              xs: 12,
              field: {
                id: "abstractNumber",
                type: "text",
                title: "Abstract Number",
                required: false,
                style: { fontSize: "10px" },
              },
            },
            {
              default: 1,
              xs: 12,
              field: {
                id: "woodedPercent",
                title: "Wooded percent",
                type: "number",
                required: false,
                max: 1,
                min: 0,
                style: { fontSize: "10px" },
              },
            },

            {
              default: 1,
              xs: 12,
              field: {
                id: "creekLength",
                type: "number",
                title: "Creek length",
                required: false,
                style: { fontSize: "10px" },
              },
            },
            {
              default: 1,
              xs: 12,
              field: {
                id: "subDivisionAge",
                type: "number",
                title: "Subdivision age",
                required: false,
                style: { fontSize: "10px" },
              },
            },
            {
              default: 1,
              xs: 12,
              field: {
                id: "difficulty",
                title: "Difficulty",
                type: "dropdown",
                required: false,
                style: { fontSize: "10px" },
                options: [...getAppChoicesFromKey(appChoices, "Difficulty")],
              },
            },
            {
              default: 1,
              xs: 12,
              field: {
                id: "distanceToPropertyInHours",
                type: "number",
                title: "Distance to property in hours",
                required: false,
                style: { fontSize: "10px" },
              },
            },
            {
              default: 3,
              field: {
                id: "comment",
                title: "Comment",
                type: "text-area",
                required: false,
                style: { fontSize: "10px" },
                rows: 1,
              },
            },
          ],
        },
      ],
    },
  ],
});

export const appraisalFileUploadForm = {
  forms: [
    {
      name: "Upload Appraisal File",
      hideFormName: true,
      markCompulsoryFields: true,
      markCompulsoryFields: true,
      submit: {
        name: "Upload",
        show: true,
        onSubmit: "onAppraisalFileFormSubmit",
      },
      rows: [
        {
          columns: [
            {
              default: 12,
              xs: 12,
              field: {
                id: "appraisalFileUpload",
                title: "Upload Appraisal File",
                type: "file",
                required: true,
              },
            },
          ],
        },
        {
          columns: [
            {
              default: 12,
              xs: 12,
              field: {
                type: "custom-html",
                html: `<h6 class='text-muted'>*<i>Please note that the file will automatically be renamed as "appraisal"</i></h6>`,
              },
            },
          ],
        },
      ],
    },
  ],
};

export const twoDigitFields = [
  "Abstract",
  "Abstract Number",
  "Block",
  "Lot",
  "Wooded percent",
  "Distance to property in hours",
];

export const fourDigitFields = [
  "Field Time",
  "Drafting Time",
  "Reviewing Time",
  "Acreage",
  "Creek length",
  "Subdivision age",
  "Difficulty",
];

export const sixDigitFields = ["Property Address"];

export const eightDigitFields = ["Latitude", "Longitude"];

export const tabs = [
  { name: "Browse Jobs", path: "browse" },
  { name: "Quoting", path: "quoting" },
  { name: "Contract Sent", path: "contract-sent" },
  { name: "Invoicing", path: "invoicing" },
  { name: "Field Setup", path: "field-setup" },
  { name: "Field Work", path: "field-work" },
  { name: "Drafting", path: "drafting" },
  { name: "Reviewing", path: "reviewing" },
  { name: "Rod Setting", path: "rod-setting" },
  { name: "Current", path: "current" },
  {
    name: "Time Tracker",
    path: "time-tracker",
    abs: true,
  },
];

export const scheduleTimeDomains = [
  "Field Time",
  "Drafting Time",
  "Reviewing Time",
];

export const statusToColors = {
  Unassigned: "", //not found
  Completed: "", //trans
  Cancelled: "", //trans
  Quoting: "#b87009",
  "Pending Approval": "#6d5f6b",
  "Agreed-send contract": "#538404",
  "Pending Confirm": "#7d3b81",
  Invoicing: "#198a7d",
  "Field Setup": "#65c906",
  "Field Work": "#28734f",
  Drafting: "#a68b09",
  Reviewing: "#b2430e",
  Archiving: "#897144",
  "Rod Setting": "#b43764",
  Stuck: "red", //not found
};

export const ADMIN_ROLE = "Admin";
export const MANAGER_ROLE = "Manager";
export const DRAFTSMAN_ROLE = "Draftsman";
export const FIELD_STAFF_ROLE = "Field Staff";
export const REVIEWER_ROLE = "Reviewer";
export const STAFF_ROLE = "Staff";

export const ALL_ROLES = [
  ADMIN_ROLE,
  MANAGER_ROLE,
  DRAFTSMAN_ROLE,
  FIELD_STAFF_ROLE,
  REVIEWER_ROLE,
  STAFF_ROLE,
];

export const LOGIN_MODE = "login";
export const REGISTER_MODE = "register";

export const getRows = (headers = [], excludedFields = []) => [
  {
    columns: (typeof headers === "function" ? headers() : headers)
      .filter((h) => !excludedFields?.includes(h.key))
      .map(
        ({
          name,
          formTitle,
          key: id,
          type = "text",
          formType,
          variant,
          label,
          showLabel,
          required = true,
          options,
          optionValues,
          defaultColumn,
          style,
        }) => ({
          default: defaultColumn || 6,
          field: {
            title: formTitle || name,
            id,
            key: id,
            type: formType || (type === "boolean" ? "checkbox" : type),
            required,
            variant,
            label,
            showLabel,
            options,
            optionValues,
            style,
          },
        })
      ),
  },
];

// Counties

export const countyHeader = [
  { name: "County", key: "county", style: { fontSize: "10px" } },
  {
    name: "Appraisal Link",
    key: "appraisalLink",
    style: { fontSize: "10px" },
  },
  {
    defaultColumn: 12,
    name: "Appraisal Map Link",
    key: "appraisalMapLink",
    style: { fontSize: "10px" },
  },
  {
    defaultColumn: 12,
    name: "County Research",
    key: "researchText",
    type: "text-area",
    style: { fontSize: "10px" },
    rows: 3,
  },
];

export const countyAddRows = getRows(countyHeader);
export const countyUpdateRows = getRows(countyHeader);

export const countySearchKeys = ["county", "researchText"];

// Users
export const userHeader = (crews) => [
  { name: "Name", key: "name", style: { fontSize: "10px" } },
  { name: "Email", key: "email", style: { fontSize: "10px" } },
  { name: "Phone", key: "phone", style: { fontSize: "10px" }, required: false },
  {
    name: "Role",
    key: "role",
    type: "dropdown",
    options: ALL_ROLES,
    style: { fontSize: "10px" },
  },
  {
    name: "Crew",
    key: "crew",
    type: "datalist-text",
    options: crews,
    style: { fontSize: "9px" },
    required: false,
  },
  {
    name: "Hourly Wage", // New column for hourly wage
    key: "hourlyWage",
    type: "number", // Assuming it's a numeric field
    style: { fontSize: "10px" },
    required: false, // Set required as true if it's a mandatory field
  },
];

export const userAddRows = (crews) => getRows(userHeader(crews));
export const userUpdateRows = (user, crews) =>
  getRows([
    ...userHeader(crews).filter(
      (uh) => uh?.key !== "email" && uh?.key !== "crew"
    ),
    {
      name: "Status",
      key: "status",
      type: "dropdown",
      options: user?.isEnabled ? USER_STATUS : USER_STATUS?.toReversed(),
    },
    {
      name: "Crew",
      key: "crew",
      type: "datalist-text",
      options: crews,
      defaultColumn: 6,
      required: false,
      style: { fontSize: "9px" },
    },
  ]);

export const userSearchKeys = ["name", "email"];

export const ADMIN_NAVS = [
  {
    label: "App Choices",
    route: "app-choices",
  },
  {
    label: "Users",
    route: "users",
  },
  {
    label: "Counties",
    route: "counties",
  },
];

export const isThisAdminNavEnabled = (nav, location) => {
  if (location?.pathname.split("/")[2].includes(nav)) {
    return true;
  }
  return false;
};

const COMMON_PROFILE_FIELDS = [
  {
    key: "name",
    label: "Name",
    type: "text",
  },

  {
    key: "phone",
    label: "Phone",
    type: "text",
  },
];

export const PROFILE_FIELDS_TO_SHOW = [
  ...COMMON_PROFILE_FIELDS,
  {
    key: "email",
    label: "Email",
    type: "email",
  },
];

export const PROFILE_FIELDS_TO_EDIT = COMMON_PROFILE_FIELDS;

export const PROFILE_PASSWORD_FIELDS = [
  {
    label: "Old Password",
    key: "oldPassword",
    type: "password",
  },
  {
    label: "New Password",
    key: "newPassword",
    type: "password",
  },
  {
    label: "Confirm Password",
    key: "confirmPassword",
    type: "password",
  },
];

export const JOBS_RELATED_FILTERS = (appChoices) => [
  {
    key: "status",
    label: "Status",
    children: STATUS.map((value) => ({
      key: value,
      label: value,
    })),
  },
  {
    key: "fieldStaff",
    label: "Field Staff",
    children: [
      { label: "Unassigned", key: null },
      ...getAppChoicesFromKey(appChoices, "users")
        ?.filter((user) => user?.role === FIELD_STAFF_ROLE)
        .map((value) => ({ key: value?._id, label: value?.name })),
      { label: "Others", key: "others" },
    ],
  },
  {
    label: "Contract Status",
    key: "contractStatus",
    children: [
      { label: "Unassigned", key: null },
      ...getAppChoicesFromKey(appChoices, "Contract Status").map((value) => ({
        key: value,
        label: value,
      })),
    ],
  },
  {
    label: "Client Priority",
    key: "clientPriority",
    children: [
      { label: "Unassigned", key: null },
      ...getAppChoicesFromKey(appChoices, "Client Priority").map((value) => ({
        key: value,
        label: value,
      })),
    ],
  },
  {
    label: "Title Company",
    key: "titleCompany",
    children: [
      { label: "Unassigned", key: null },
      ...getAppChoicesFromKey(appChoices, "Title Company").map((value) => ({
        key: value,
        label: value,
      })),
    ],
  },
];

export const SERVICE_REQUEST_FILE_UPLOAD = [
  {
    label: "Upload Title Commitment",
    key: "uploadTitleCommitment",
  },
  {
    label: "Upload copy of previous survey",
    key: "uploadCopyOfPrevoiusSurvey",
  },
  {
    label:
      "Upload copy of previous recorded deed or recorded sub division plats",
    key: "uploadCopyOfPrevoiusRecordDeeds",
  },
];

export const BROWSE_JOBS_SORT_OPTIONS = [
  {
    key: "titleClosingDate",
    label: "Title Closing Date",
  },
  {
    key: "titleClosingDate",
    label: "Title CLosing Date",
  },
  {
    key: "updatedAt",
    lalebl: "Updated At",
  },
  {
    key: "createdAt",
    label: "Created At",
  },
  {
    key: "proposedDueDate",
    label: "Proposed Due Date",
  },
  {
    key: "agreedDueDate",
    label: "Agreed Due Date",
  },
];

export const defaultProposedDateAppChoiceKey = "DEFAULT PROPOSED DATE DIFF";
export const defaultScheduledClosingDateDiffAppChoiceKey =
  "DEFAULT SCHEDULED CLOSING DATE DIFF";
